import { useHistory } from "react-router-dom";

import { Grid } from "@material-ui/core";
import Pagination from "./Pagination";

const Paginator = ({ top = true, bottom = true, queryParams = {}, componentTopBefore = null, ...rest }) => {
    const { children } = rest || {};

    const history = useHistory();

    let currentQuery = Object.fromEntries(new URLSearchParams(window.location.search));

    if (!queryParams?.search) {
        delete queryParams?.search;
        delete currentQuery?.search;
    }

    const newQuery = queryParams?.search?.length
        ? new URLSearchParams({
              ...currentQuery,
              ...queryParams,
              search: encodeURI(queryParams?.search),
          }).toString()
        : new URLSearchParams({
              ...currentQuery,
              ...queryParams,
          }).toString();

    const currentPath = `${history.location.pathname}${history.location.search}${history.location.hash}`;
    const newPath = `${history.location.pathname}?${newQuery}${history.location.hash}`;

    // console.log(` ------------------------------------`);
    // console.log(`Paginator ~ queryParams:`, queryParams);
    // console.log({ currentQuery, newQuery, currentPath, newPath });
    // console.log(
    //     queryParams?.search,
    //     queryParams?.search?.length,
    // );
    // console.log(` ------------------------------------`);
    if (currentPath !== newPath) {
        setTimeout(() => {
            history.push(newPath, { shallow: true });
        }, 100);
    }

    return (
        <>
            {!!top && (
                <Grid container spacing={1}>
                    <Grid
                        item
                        xs={componentTopBefore ? 12 : false}
                        md={componentTopBefore ? 5 : 5}
                        style={{ display: "flex", alignItems: "center", justifyContent: "start", paddingTop: 8 }}
                    >
                        {componentTopBefore}
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={7}
                        style={{ display: "flex", alignItems: "center", justifyContent: "end", paddingTop: 8 }}
                    >
                        <Pagination {...rest} />
                    </Grid>
                </Grid>
            )}

            {children}

            {!!bottom && <Pagination {...rest} />}
        </>
    );
};

export default Paginator;
